import {
  Input,
  SelectFilter,
} from '@prio365/prio365-react-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../../../../components/Flex';
import { makePrioStyles } from '../../../../../theme/utils';

const useStyles = makePrioStyles((theme) => ({
  switchesContainer: {
    background: 'white',
    padding: '16px',
    borderRadius: '4px',
    margin: '32px 0 16px 0',
  },
}));

const ACTION_FILTER_OPTIONS = [
  { value: 'notset', label: 'Nicht festgelegt' },
  { value: 'skip', label: 'Überspringen' },
  { value: 'create', label: 'Erstellen' },
  { value: 'updatemissing', label: 'Fehlende aktualisieren' },
  { value: 'overrideexisting', label: 'Bestehende überschreiben' },
];

interface ContactImporterFilterBarProps {
  className?: string;
  searchChangeHandler?: (value: any) => void;
  actionFilter?: string | null;
  onActionFilterChange?: (action: string | null) => void;
}

export const ContactImporterFilterBar: React.FC<
  ContactImporterFilterBarProps
> = ({ searchChangeHandler, actionFilter, onActionFilterChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  // SelectFilter onChange returns string[] of selected option values
  const handleActionFilterChange = (selectedValues: string[]) => {
    if (!onActionFilterChange) return;
    if (selectedValues.length === 0 || selectedValues.length === ACTION_FILTER_OPTIONS.length) {
      // All or none selected = no filter
      onActionFilterChange(null);
    } else if (selectedValues.length === 1) {
      onActionFilterChange(selectedValues[0]);
    } else {
      // Multiple selected — use first one as filter (single-select behavior)
      onActionFilterChange(selectedValues[selectedValues.length - 1]);
    }
  };

  // Build selectedOptions array for SelectFilter
  const selectedOptions = actionFilter ? [actionFilter] : ACTION_FILTER_OPTIONS.map((o) => o.value);

  return (
    <Flex.Row
      className={classes.switchesContainer}
      alignItems="center"
      justifyContent="start"
      childrenGap={30}
    >
      <Input
        size="small"
        placeholder={t('searchPlaceHolder')}
        prefixIcon={['fal', 'magnifying-glass']}
        onChange={searchChangeHandler}
      />
      {onActionFilterChange && (
        <Flex.Row alignItems="center" childrenGap={20}>
          <SelectFilter
            options={ACTION_FILTER_OPTIONS.map((opt) => ({
              ...opt,
              activeByDefault: true,
            }))}
            selectedOptions={selectedOptions}
            onChange={handleActionFilterChange}
            shouldUseTriggerButton={true}
            triggerButtonPlaceholder={t('settings:companyImport.filter.action')}
          />
        </Flex.Row>
      )}
    </Flex.Row>
  );
};

export default ContactImporterFilterBar;
